import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export const GRID_VALUES = [
  { value: "left top", icon: "arrow-top-left" },
  { value: "center top", icon: "arrow-top-center" },
  { value: "right top", icon: "arrow-top-right" },
  { value: "left center", icon: "arrow-center-left" },
  { value: "center", icon: "arrow-center" },
  { value: "right center", icon: "arrow-center-right" },
  { value: "left bottom", icon: "arrow-bottom-left" },
  { value: "center bottom", icon: "arrow-bottom-center" },
  { value: "right bottom", icon: "arrow-bottom-right" },
];

export default class ObjectPosition extends BaseOption {
  static userInterfaceComponent = {
    label: "Object Position",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: GRID_VALUES,
      defaultIcon: "dot",
    },
  };

  static defaultValue = "center";

  static convertConfigValueToCompiledValue(configValue) {
    if (GRID_VALUES.map(item => item.value).includes(configValue)) {
      return configValue;
    }
    return "center";
  }
}
